export default {
  PackageOptions__BUTTON_GROUP_ARIA_NEXT: "Next",
  PackageOptions__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  PackageOptions__FLIGHT: "Flight",
  PackageOptions__FLIGHT_CAR: "Flight + Car",
  PackageOptions__FLIGHT_HOTEL: "Flight + Hotel",
  PackageOptions__FLIGHT_HOTEL_CAR: "Flight + Hotel + Car",
  PackageOptions__PLUS_CAR: "+ Car",
  PackageOptions__PLUS_HOTEL: "+ Hotel",
};
